/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Profile = Loadable(lazy(() => import("sections/profile/profile")));

const profileRoutes = [
    {
        path: "profile",
        element: <Profile />,
    },
];

export { profileRoutes };
